import dayjs from 'dayjs'

import weeklyMission from './missions/weekly-mission.json'
import monthlyMission from './missions/monthly-mission.json'
import eventMission from './missions/event-mission.json'
import actionBasedMission from './missions/action-based.json'

const today = dayjs()
const nextWeekSunday = today.add(1, 'week').startOf('week')
const nextWeekSaturday = nextWeekSunday.add(6, 'day')

weeklyMission.start_date = nextWeekSunday.format('YYYY-MM-DD')
weeklyMission.end_date = nextWeekSaturday.format('YYYY-MM-DD')
weeklyMission.mission_dates.forEach((el, index) => {
  el.date = nextWeekSunday.add(index, 'day').format('YYYY-MM-DD')
})

const nextMonth = today.add(1, 'month').startOf('month')
monthlyMission.start_date = nextMonth.format('YYYY-MM-DD')
monthlyMission.end_date = nextMonth.add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD')
monthlyMission.mission_dates.forEach((el, index) => {
  el.date = nextMonth.add(index, 'day').format('YYYY-MM-DD')
})

const tomorrow = today.add(1, 'day').format('YYYY-MM-DD')
eventMission.start_date = tomorrow
eventMission.end_date = today.add(4, 'day').format('YYYY-MM-DD')
eventMission.mission_dates.forEach((el, index) => {
  el.date = today.add(index, 'day').format('YYYY-MM-DD')
})

actionBasedMission.start_date = tomorrow
actionBasedMission.end_date = today.add(4, 'day').format('YYYY-MM-DD')

export const MISSION_SETTINGS = {
  data: {
    coin_name: {
      'th-TH': 'เหรียญ',
      'zh-CN': '硬币',
      'en-US': 'Point'
    },
    mission_layout: 3,
    reset_coin_status: false,
    status: true,
    file: 'b78b2af0-1e4a-41b6-b9e7-39bb2b38b21b.png',
    mission_type_settings: {
      1: {
        mission_type_name: 'Weekly mission',
        status: true
      },
      2: {
        mission_type_name: 'Monthly mission',
        status: true
      },
      3: {
        mission_type_name: 'Event trigger',
        status: true
      },
      4: {
        mission_type_name: 'Action base',
        status: true
      }
    }
  }
}

const weeklyMissionClone = JSON.parse(JSON.stringify(weeklyMission))
delete weeklyMissionClone.mission_dates

export const MISSION_LISTS_WEEKLY = {
  data: [weeklyMissionClone]
}

const monthlyMissionClone = JSON.parse(JSON.stringify(monthlyMission))
delete monthlyMissionClone.mission_dates

export const MISSION_LISTS_MONTHLY = {
  data: [monthlyMissionClone]
}
const eventMissionClone = JSON.parse(JSON.stringify(eventMission))
delete eventMissionClone.mission_dates
export const MISSION_LISTS_EVENT = {
  data: [eventMissionClone]
}

const actionBasedClone = JSON.parse(JSON.stringify(actionBasedMission))
delete actionBasedClone.mission_dates

export const MISSION_LISTS_ACTION_BASED = {
  data: [actionBasedClone]
}

export const MISSION_BADGES = {
  data: { all_missions: 0, mission_type: { 1: 0, 2: 0, 3: 0, 4: 0 } }
}

export const EXCHANGE_REWARDS_TYPE_1 = {
  data: {
    data: [
      {
        id: 'a0444b73-e429-44ba-89fd-233843920db1',
        name: {
          'en-US': 'all tiers'
        },
        file: 'all.png',
        sequence: 0,
        tier_type: 2
      },
      {
        id: '5f63d4a5-51e1-4d06-8fd4-4fbf8b8180df',
        name: {
          'en-US': 'Bronze',
          'th-TH': 'Bronze',
          'zh-CN': 'Bronze'
        },
        file: 'bronze.png',
        sequence: 1,
        tier_type: 1
      },
      {
        id: 'f54a8882-1d80-46ec-b6b3-72b63fcf4c4a',
        name: {
          'en-US': 'Silver',
          'th-TH': 'Silver',
          'zh-CN': 'Silver'
        },
        file: 'silver.png',
        sequence: 1,
        tier_type: 1
      },
      {
        id: 'e804da89-2283-45ce-a590-df7035df8266',
        name: {
          'en-US': 'Gold',
          'th-TH': 'Gold',
          'zh-CN': 'Gold'
        },
        file: 'gold.png',
        sequence: 1,
        tier_type: 1
      },
      {
        id: '3c9d3b36-051e-4554-b817-956d55f29e20',
        name: {
          'en-US': 'Diamond',
          'th-TH': 'Diamond',
          'zh-CN': 'Diamond'
        },
        file: 'diamond.png',
        sequence: 2,
        tier_type: 1
      },
      {
        id: 'dd5d4e13-873f-4aaa-801c-4b4ed339158a',
        name: {
          'en-US': 'Platinum',
          'th-TH': 'Platinum',
          'zh-CN': 'Platinum'
        },
        file: 'platinum.png',
        sequence: 3,
        tier_type: 1
      }
    ]
  }
}
export const EXCHANGE_REWARDS_TYPE_2 = {
  data: {
    data: [
      {
        id: 'a0444b73-e429-44ba-89fd-233843920db1',
        name: {
          'en-US': 'all tiers'
        },
        file: 'all.png',
        sequence: 1,
        tier_type: 2
      },
      {
        id: '5f63d4a5-51e1-4d06-8fd4-4fbf8b8180df',
        name: {
          'en-US': 'Bronze',
          'th-TH': 'Bronze',
          'zh-CN': 'Bronze'
        },
        file: 'bronze.png',
        sequence: 2,
        tier_type: 1
      },
      {
        id: 'f54a8882-1d80-46ec-b6b3-72b63fcf4c4a',
        name: {
          'en-US': 'Silver',
          'th-TH': 'Silver',
          'zh-CN': 'Silver'
        },
        file: 'silver.png',
        sequence: 3,
        tier_type: 1
      },
      {
        id: 'e804da89-2283-45ce-a590-df7035df8266',
        name: {
          'en-US': 'Gold',
          'th-TH': 'Gold',
          'zh-CN': 'Gold'
        },
        file: 'gold.png',
        sequence: 4,
        tier_type: 1
      },
      {
        id: '3c9d3b36-051e-4554-b817-956d55f29e20',
        name: {
          'en-US': 'Diamond',
          'th-TH': 'Diamond',
          'zh-CN': 'Diamond'
        },
        file: 'diamond.png',
        sequence: 5,
        tier_type: 1
      },
      {
        id: 'dd5d4e13-873f-4aaa-801c-4b4ed339158a',
        name: {
          'en-US': 'Platinum',
          'th-TH': 'Platinum',
          'zh-CN': 'Platinum'
        },
        file: 'platinum.png',
        sequence: 6,
        tier_type: 1
      }
    ]
  }
}

export const EXCHANGE_REWARDS = {
  data: {
    data: [
      {
        id: '7685b47e-e5f2-44c0-b46f-97d528cda34a',
        reward_type: 1,
        tier_id: 'e75de843-4e80-4bc5-abad-0e732ee8e685',
        file: 'f243c25b-3479-43b8-b0e1-5688d15bacaf.png',
        name: {
          'en-US': '1',
          'th-TH': '1'
        },
        amount_required: 1,
        sequence: 1,
        credit_amount: '1'
      },
      {
        id: 'fea698f7-98a3-4b01-b1a5-4035ef03539f',
        reward_type: 1,
        tier_id: 'e75de843-4e80-4bc5-abad-0e732ee8e685',
        file: '261ed4fa-b4c7-4849-975e-3d48b7af151e.png',
        name: {
          'en-US': '1',
          'th-TH': '1'
        },
        amount_required: 1,
        sequence: 2,
        credit_amount: '1'
      }
    ]
  }
}

export const EXCHANGE_REWARD_TNC = {
  data: {
    data: {
      'en-US':
        '<h3><span style="color: rgb(255, 255, 255);">🪙 </span><strong style="color: rgb(255, 255, 255);"><u>Terms of Exchange: Coin to Rewards</u></strong></h3><p><br></p><ol><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">Eligibility: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">The coin exchange feature is available to users in </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">specific VIP tiers only</strong><span style="background-color: transparent; color: rgb(255, 255, 255);">. Access may vary depending on your membership level.</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">Sufficient Balance: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">Users must have a </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">sufficient coin balance</strong><span style="background-color: transparent; color: rgb(255, 255, 255);"> to complete the exchange. Coins cannot be borrowed or reserved for future redemptions.</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">Minimum Exchange Amount:</strong><span style="background-color: transparent; color: rgb(255, 255, 255);"> A minimum number of coins is required for each transaction. Partial redemptions or under-limit amounts will not be processed.</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">Reward Types:</strong><span style="background-color: transparent; color: rgb(255, 255, 255);"> Available rewards include </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">credits to wallet, vouchers, gift cards, bonus items</strong><span style="background-color: transparent; color: rgb(255, 255, 255);">, and more. The selection may vary by availability and region.</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">Reward Delivery: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">Rewards will be delivered within </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">14 business days</strong><span style="background-color: transparent; color: rgb(255, 255, 255);"> following a successful exchange. Some items may require additional verification.</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">Non-Refundable: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">All coin exchanges are </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">final and non-refundable</strong><span style="background-color: transparent; color: rgb(255, 255, 255);">. Once coins are redeemed, they cannot be returned or reversed.</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">Fraud Prevention: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">Any suspicious or fraudulent activity will lead to </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">cancellation of the exchange</strong><span style="background-color: transparent; color: rgb(255, 255, 255);">, and may result in account suspension.</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">Modification &amp; Termination: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">We reserve the right to modify or terminate the coin exchange program at any time, with or without prior notice.</span></li><li><strong style="color: rgb(255, 255, 255); background-color: transparent;">Physical Items Exchange:</strong><span style="color: rgb(255, 255, 255); background-color: transparent;"> We reserve the right to </span><strong style="color: rgb(255, 255, 255); background-color: transparent;">approve or reject any coin exchanges for physical items</strong><span style="color: rgb(255, 255, 255); background-color: transparent;">. If rejected, a </span><strong style="color: rgb(255, 255, 255); background-color: transparent;">clear reason will be provided</strong><span style="color: rgb(255, 255, 255); background-color: transparent;"> to you.</span></li></ol><p><br></p>',
      'th-TH':
        '<h3>🪙 <u style="background-color: transparent; color: rgb(255, 255, 255);">เงื่อนไขการแลกเหรียญเป็นของรางวัล</u></h3><p><br></p><ol><li><strong style="background-color: transparent;">สิทธิ์ในการแลก: </strong><span style="background-color: transparent;">ฟีเจอร์การแลกเหรียญจะเปิดให้เฉพาะผู้ใช้งานในระดับ </span><strong style="background-color: transparent;">VIP ที่กำหนดเท่านั้น</strong><span style="background-color: transparent;"> โดยสิทธิ์การเข้าถึงอาจแตกต่างกันตามระดับสมาชิก</span></li><li><strong style="background-color: transparent;">ต้องมีเหรียญเพียงพอ: </strong><span style="background-color: transparent;">ผู้ใช้จะต้องมีจำนวนเหรียญ </span><strong style="background-color: transparent;">เพียงพอสำหรับการแลกเปลี่ยน</strong><span style="background-color: transparent;"> ไม่สามารถยืมหรือสำรองเหรียญไว้ล่วงหน้าได้</span></li><li><strong style="background-color: transparent;">จำนวนแลกขั้นต่ำ: </strong><span style="background-color: transparent;">ต้องแลกเหรียญตามจำนวนขั้นต่ำที่กำหนด ไม่สามารถแลกเหรียญบางส่วนหรือจำนวนน้อยกว่าข้อกำหนดได้</span></li><li><strong style="background-color: transparent;">ประเภทของรางวัล: </strong><span style="background-color: transparent;">ของรางวัลรวมถึง </span><strong style="background-color: transparent;">เครดิตเข้ากระเป๋าเงิน, คูปอง, บัตรของขวัญ, ไอเทมโบนัส</strong><span style="background-color: transparent;"> และอื่น ๆ โดยของรางวัลอาจแตกต่างกันตามพื้นที่และความพร้อมให้บริการ</span></li><li><strong style="background-color: transparent;">ระยะเวลาจัดส่งของรางวัล: </strong><span style="background-color: transparent;">ของรางวัลจะถูกจัดส่งภายใน </span><strong style="background-color: transparent;">14 วันทำการ</strong><span style="background-color: transparent;"> หลังจากที่ทำการแลกสำเร็จ รายการบางอย่างอาจต้องมีการตรวจสอบเพิ่มเติม</span></li><li><strong style="background-color: transparent;">ไม่สามารถขอคืนได้: </strong><span style="background-color: transparent;">การแลกเหรียญทุกครั้งถือว่า </span><strong style="background-color: transparent;">สิ้นสุดและไม่สามารถขอคืนได้</strong><span style="background-color: transparent;"> เมื่อแลกแล้วจะไม่สามารถย้อนกลับหรือยกเลิกได้</span></li><li><strong style="background-color: transparent;">การป้องกันการทุจริต: </strong><span style="background-color: transparent;">หากพบกิจกรรมที่น่าสงสัยหรือมีเจตนาโกง การแลกเหรียญจะถูก </span><strong style="background-color: transparent;">ยกเลิกทันที</strong><span style="background-color: transparent;"> และอาจมีการระงับบัญชีผู้ใช้งาน</span></li><li><strong style="background-color: transparent;">การแก้ไขหรือยกเลิกฟีเจอร์: </strong><span style="background-color: transparent;">ทางเราขอสงวนสิทธิ์ในการเปลี่ยนแปลงหรือยกเลิกฟีเจอร์การแลกเหรียญได้ทุกเมื่อ โดยไม่จำเป็นต้องแจ้งล่วงหน้า</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">การแลกของรางวัลที่เป็นสินค้าจริง: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">เราขอสงวนสิทธิ์ในการ </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">อนุมัติหรือปฏิเสธคำขอแลกเหรียญเป็นสินค้าจริง</strong><span style="background-color: transparent; color: rgb(255, 255, 255);"> โดยจะมีการแจ้งเหตุผลให้คุณทราบอย่างชัดเจนหากมีการปฏิเสธ</span></li></ol>',
      'zh-CN':
        '<h3><span style="color: rgb(255, 255, 255);">🪙 </span><u style="background-color: transparent; color: rgb(255, 255, 255);">兑换金币为奖励的条款</u></h3><p><br></p><ol><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">兑换资格: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">兑换功能仅对特定的 </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">VIP等级用户</strong><span style="background-color: transparent; color: rgb(255, 255, 255);"> 开放，权限依用户等级而异。</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">金币余额要求: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">用户必须拥有 </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">足够的金币</strong><span style="background-color: transparent; color: rgb(255, 255, 255);"> 才能进行兑换，无法借用或预留金币进行操作。</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">最低兑换数量: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">每次兑换需满足最低金币数量要求，不支持部分兑换或不足额兑换。</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">奖励类型: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">奖励包括 </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">钱包余额、代金券、礼品卡、奖励道具</strong><span style="background-color: transparent; color: rgb(255, 255, 255);"> 等，实际内容可能因地区或库存情况有所不同。</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">奖励发放时间: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">奖励将在成功兑换后的 </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">14个工作日内</strong><span style="background-color: transparent; color: rgb(255, 255, 255);"> 发放。部分实物或特殊项目可能需要额外验证。</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">不可退款: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">所有金币兑换均为 </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">最终操作，无法取消或退款</strong><span style="background-color: transparent; color: rgb(255, 255, 255);">，请确认后再进行兑换。</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">欺诈防范: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">若发现有欺诈或可疑行为，兑换将被 </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">立即取消</strong><span style="background-color: transparent; color: rgb(255, 255, 255);">，并可能暂停用户账户权限。</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">修改与终止权利: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">我们保留随时 </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">修改或终止</strong><span style="background-color: transparent; color: rgb(255, 255, 255);"> 金币兑换活动的权利，恕不另行通知。</span></li><li><strong style="background-color: transparent; color: rgb(255, 255, 255);">兑换实物商品说明: </strong><span style="background-color: transparent; color: rgb(255, 255, 255);">&nbsp;对于兑换为</span><strong style="background-color: transparent; color: rgb(255, 255, 255);">实物商品</strong><span style="background-color: transparent; color: rgb(255, 255, 255);">的请求，我们保留 </span><strong style="background-color: transparent; color: rgb(255, 255, 255);">接受或拒绝的权利</strong><span style="background-color: transparent; color: rgb(255, 255, 255);">。若被拒绝，我们将向您提供明确的理由说明。</span></li></ol>'
    }
  }
}

export const MISSION_DETAIL = {
  // Happy weekly missions
  'ec7877c8-3793-4d28-bc41-bf67ef741fa5': weeklyMission,
  // Monthly missions
  'd4f9a42b-6f06-45dc-bbed-3b0db620d935': monthlyMission,
  // Event trigger missions
  '73e2a219-f686-40a9-8419-245d25dd9cbb': eventMission,
  // Action based missions
  '1bde09a3-9796-438d-9e53-861b72b67977': actionBasedMission
}
